import { render, staticRenderFns } from "./TableViewAddTak.vue?vue&type=template&id=4da8a64a&scoped=true"
import script from "./TableViewAddTak.vue?vue&type=script&lang=js"
export * from "./TableViewAddTak.vue?vue&type=script&lang=js"
import style0 from "./TableViewAddTak.vue?vue&type=style&index=0&id=4da8a64a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da8a64a",
  null
  
)

export default component.exports